export const EMPLOYEE_PROFILE_FORM_TEST_ID = 'employee-profile-form-test-id';
export const ADD_DEPENDENT_MODAL_TEST_ID = 'add-dependent-modal-test-id';
export const EMPLOYEE_PROFILE_TAB_TEST_ID = 'employee-profile-tab-test-id';
export const DEPENDENTS_TAB_TEST_ID = 'dependents-tab-test-id';
